import * as React from 'react';

import PublicIcon from '@mui/icons-material/Public';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { COLORS } from '../../../styles/theme';

interface Props {
  handleClose: () => void;
  report: reports.AllReportsQueryRow;
  setShowMapOnlyApprovalModal: React.Dispatch<React.SetStateAction<boolean>>;
  setReportId: React.Dispatch<React.SetStateAction<string>>;
  setReportRowId: React.Dispatch<React.SetStateAction<number>>;
}

const ApproveMapOnlyMenuItem: React.FC<Props> = ({
  handleClose,
  report,
  setShowMapOnlyApprovalModal,
  setReportId,
  setReportRowId,
}) => {
  const { t } = useTranslation();

  return (
    <MenuItem onClick={handleClose} href="">
      <ListItemButton
        onClick={() => {
          setShowMapOnlyApprovalModal(true);
          setReportId(report.reportId);
          setReportRowId(report.id);
        }}
      >
        <ListItemIcon>
          <PublicIcon fontSize="small" htmlColor={COLORS.AQUA_MARINE} />
        </ListItemIcon>
        <ListItemText primary={t('reportsQa.menu.approveMapOnly')} />
      </ListItemButton>
    </MenuItem>
  );
};

export default ApproveMapOnlyMenuItem;
